import {BaseApi, HttpMethodEnum} from '../BaseApi/BaseApi';
import {ISimulation, ISimulationCurveGraph, ISimulationPayload} from '../../entities/Simulation/Simulation.ts';

export class SimulationApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Simulations`;

    public static apiUrls = {
        getDefaultSimulation: `${BaseApi.apiUrl}/Patients/:id/DefaultSimulation`,
        getSimulationById: `${SimulationApi.baseApiUrl}/:id`,
        postSimulation: `${SimulationApi.baseApiUrl}`,
        postSimulationRun: `${SimulationApi.baseApiUrl}/run`,
        putSimulation: `${SimulationApi.baseApiUrl}/:id`,
        deleteSimulation: `${SimulationApi.baseApiUrl}/:id`,
    };

    public static async getSimulationById(id: string): Promise<ISimulation> {
        return this.sendApiRequest<ISimulation>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getSimulationById,
            data: undefined,
            id: id
        });
    }

    public static async getDefaultSimulation(id: string): Promise<ISimulation> {
        return this.sendApiRequest<ISimulation>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getDefaultSimulation,
            data: undefined,
            id: id
        });
    }

    public static async postSimulation(data: ISimulationPayload): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postSimulation,
            data: data
        });
    }

    public static async postSimulationRun(data: ISimulationPayload): Promise<ISimulationCurveGraph> {
        return this.sendApiRequest<ISimulationCurveGraph>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.postSimulationRun,
            data: data
        });
    }

    public static async putSimulation(id: string, data: ISimulationPayload): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putSimulation,
            data: data,
            id: id
        });
    }

    public static async deleteSimulation(id: string): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deleteSimulation,
            data: undefined,
            id: id
        });
    }
}
